import { readTenantFilters, removeTenantFilters, writeTenantFilters } from "./filtersTenantStorage";

// Stored per tenant and user, see filtersTenantStorage.
const CLAIM_FILTER_STORAGE_KEY = "sidebarClaimFilter";

export interface IPersistedClaimFilter {
  claimId: string;
  isApplied: boolean;
}

/** Loads the claim filter chip's last state (which claim, applied or cleared)
 * so it survives a page refresh. Shared between Sidebar (restores the chat
 * list filter) and ClaimsTable (selects the matching row once its data loads). */
export function loadPersistedClaimFilter(scope: string | null): IPersistedClaimFilter | null {
  const parsed = readTenantFilters(CLAIM_FILTER_STORAGE_KEY, scope) as Partial<IPersistedClaimFilter> | null;
  if (parsed?.claimId) {
    return {
      claimId: parsed.claimId,
      isApplied: parsed.isApplied !== false,
    };
  }
  return null;
}

export function savePersistedClaimFilter(scope: string | null, filter: IPersistedClaimFilter): void {
  writeTenantFilters(CLAIM_FILTER_STORAGE_KEY, scope, filter);
}

export function clearPersistedClaimFilter(scope: string | null): void {
  removeTenantFilters(CLAIM_FILTER_STORAGE_KEY, scope);
}
